<script lang="ts">
  import { onDestroy } from 'svelte'
  import { locale } from 'svelte-i18n'
  import TextPage from '../components/TextPage.svelte'
  import { fetchCookiesPolicy } from '../controllers/PoliciesController'
  import { cookiesPolicyData } from '../stores/stores'

  let lang = $locale ?? String(process.env.LOCALE)

  const unsubscribeLocale = locale.subscribe(() => {
    lang = $locale!
  })

  void fetchCookiesPolicy(lang)

  onDestroy(() => {
    unsubscribeLocale()
  })
</script>

{#if $cookiesPolicyData?.title && $cookiesPolicyData?.policy}
  <TextPage title={$cookiesPolicyData?.title} text={$cookiesPolicyData?.policy} />
{/if}
